export default __webpack_public_path__ + "static/media/DSC_5610.849ef5e0.jpg";